import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const FullScreenSpinner = () => (
  <div data-testid="auth-loading" className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#8B6F47] border-t-transparent rounded-full animate-spin" />
  </div>
);

export const ProtectedRoute = () => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullScreenSpinner />;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
};
